// js/helper/currency.js
// 页面刷新时判断价格
window.onload = function() {
    if(localStorage.getItem('tcs') == null){
       $(".customizer_last_price1").show();
       $(".customizer_last_price").hide();
     
       var customizer_last_price1 = $(".customizer_last_price1").html();
       $(".customizer_last_price").html(customizer_last_price1)
     
    }else{
        $(".customizer_last_price").show();
        $(".customizer_last_price1").hide();
    }
}
function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
// 除去所有的特殊符号
function palindrome(str) {
    var arr = str.replace(/[$,]/g,
      '');

    return Number(arr) * 100
}
$(function () {
  
    // // 轮播
    // var swiper = new Swiper(".customizerSwiper", {
    //     slidesPerView: 'auto',
    //     spaceBetween: 30,
      
    // });     

})
// tab切换
$(".customizer_rightBox_tab .swiper-slide").click(function () {

    $(this).addClass("active active::after").siblings("div").removeClass("active");
    var index = $(this).index();
    $(".customizer_rightBox_div>.rightBox_divHide:eq(" + index + ")").fadeIn(1000).siblings(".rightBox_divHide").hide()
})
// 点击小组件
$(".rightBox_divHide .rightBox_divHideBoxImg").click(function () {

    $(this).parent().find(".divHideBox_details").show();
    $(this).parent().siblings().find(".divHideBox_details").hide();
    $(".rightBox_divHideBoxImg").hide()

    if ($(this).find("img").hasClass("rightBox_divHideBox_imgBorder")) {
        $(this).parent().find(".customizerCha_um").show();
        $(this).parent().find(".customizerCha_add_item").hide();
    } else {
        $(this).parent().find(".customizerCha_add_item").show();
        $(this).parent().find(".customizerCha_um").hide();
    }



})
// 详情关闭
$(".rightBox_divHide .divHideBox_details #customizer_cha").click(function () {

    $(".rightBox_divHideBoxImg").show()
    $(this).parent().hide()


})
// // 详情描述
// $(".customizerCha_detail_top").click(function () {
//     $(this).find("svg").toggleClass("customizerCha_topIcon")
//     $(this).next().slideToggle();
// })
// free 的产品
var freeValue = $(".rightBox_divHide:nth-child(2) .rightBox_divHideBox .rightBox_divHideBox_hide:nth-child(1) .variants_Value").html();
var freeValue2 =$(".rightBox_divHide:nth-child(2) .rightBox_divHideBox .rightBox_divHideBox_hide:nth-child(2) .variants_Value").html();
// console.log(freeValue,freeValue2)

// 当前自行车变体
var variantsId = $(".bike_customizer_variantsId").html();

var addPush = [variantsId,freeValue,freeValue2];
// 添加 变体图片

let data=[
    
]
$(".customizerCha_add_item").click(function () {
   
    $(this).parent().parent().hide()
    $(".rightBox_divHideBoxImg").show()
    $(this).parent().parent().parent().find(".rightBox_divHideBox_img img").addClass("rightBox_divHideBox_imgBorder");
     // 当前点击的价格
     var currentPrice = $(this).parent().find(".customizerCha_price").html();
     // 左侧总价
     var GudingPrice = $(".customizer_last_price").html();
   
    var current = palindrome(currentPrice);
    var Guding = palindrome(GudingPrice)
  
    var zong = Number(current)+Number(Guding);
  
    let allSaveDom = document.querySelector('.price-save span');
    let checkDoms = document.querySelectorAll('.rightBox_divHideBox_imgBorder');
    let allsave = 0
    checkDoms.forEach(e=>{
      let yuan = e.parentElement.parentElement.querySelector('.rightBox_divHideBox_myPrice').innerText
      let xian = e.parentElement.parentElement.querySelector('.rightBox_divHideBox_price').innerText
      allsave += palindrome(yuan) - palindrome(xian)
    })

    allSaveDom.innerHTML = allsave/100
    if(allsave > 0) {
      allSaveDom.parentElement.style.display = 'block'
    } else {
      allSaveDom.parentElement.style.display = 'none'
    }
    var trzong = formatMoney(zong)
    
    // 添充后的价格
    var tc = $(".customizer_last_price").html(trzong)
    // 变体id存储
    var  addItem = $(this).parent().parent().find(".variants_Value").html();
    addPush.push(addItem)
    
    // 去重
    Array.from(new Set(addPush))
  

    // 更新和移除显示
    $(this).find(".customizerCha_um").show();
    $(this).hide();


    
 
    
})
var daima = localStorage.getItem('tcs');
$(".customizer_last_price").html(daima)


// 更新和移除点击事件
$(".customizerCha_Update").click(function () {

    $(this).parent().parent().parent().hide();
    $(".rightBox_divHideBoxImg").show();
    $(this).parent().parent().parent().parent().find(".rightBox_divHideBox_img img").addClass("rightBox_divHideBox_imgBorder");


})

$(".customizerCha_Remove").click(function () {
   
     // 变体id移除
    var RemoveItem = $(this).parent().parent().parent().find(".variants_Value").html();
    var index = addPush.indexOf(RemoveItem)
  
    addPush.splice(index,1)
   
    $(this).parent().hide();
    $(this).parent().parent().find(".customizerCha_add_item").show();
    $(this).parent().parent().parent().hide();
    $(".rightBox_divHideBoxImg").show();
    
  

    // 价格移除
    // 价格
    // 当前点击的价格
    // 
    var currentPrice = $(this).parent().parent().find(".customizerCha_price").html();


    // 左侧总价
    var GudingPrice = $(".customizer_last_price").html();
    
   

    var current = palindrome(currentPrice);
    let allSaveDom = document.querySelector('.price-save span');
    let checkDoms = document.querySelectorAll('.rightBox_divHideBox_imgBorder');
    let allsave = 0
    checkDoms.forEach(e=>{
      let yuan = e.parentElement.parentElement.querySelector('.rightBox_divHideBox_myPrice').innerText
      let xian = e.parentElement.parentElement.querySelector('.rightBox_divHideBox_price').innerText
      allsave += palindrome(yuan) - palindrome(xian)
    })

    allSaveDom.innerHTML = allsave/100
    if(allsave > 0) {
      allSaveDom.parentElement.style.display = 'block'
    } else {
      allSaveDom.parentElement.style.display = 'none'
    }

    var Guding = palindrome(GudingPrice)
  
    var zong = Number(Guding)-Number(current);
    
    // console.log("剩余"+ addPush)

    var trzong = formatMoney(zong)
  
    // 添充后的价格
    
    // let ss = $(this).parent().parent().find(".customizerCha_add_item")[0];
    // console.log(ss.style)
    if($(this).parent().parent().parent().parent().find(".rightBox_divHideBox_img img").hasClass("rightBox_divHideBox_imgBorder")) {
      $(".customizer_last_price").html(trzong)
      $(this).parent().parent().parent().parent().find(".rightBox_divHideBox_img img").removeClass("rightBox_divHideBox_imgBorder");
    }
})

// 套装
// 当有选择配件的时候重置
$(".rightBox_divHideBox_hide .customizer_suit").click(function(){
    
})
// x 号关闭弹窗
$(".bike_customizer_Warning_cha").click(function(){
    $(".bike_customizer_Warning").hide();
    $(".no-focus-outline").addClass("overflowHtml")
    $(".bike_customizer_bg").removeClass("bike_customizer_bgs");
})

// Cancel
$(".customizer_warning_cancel").click(function(){
    $(".bike_customizer_Warning").hide();
    $(".no-focus-outline").addClass("overflowHtml")
    $(".bike_customizer_bg").removeClass("bike_customizer_bgs");
})

// On no
// 差
$(".bike_customizer_Oh_no_cha").click(function(){
    $(".bike_customizer_Oh_no").hide();
    $(".no-focus-outline").addClass("overflowHtml")
    $(".bike_customizer_bg").removeClass("bike_customizer_bgs");
})

// Cancel
$(".customizer_Oh_no_cancel").click(function(){
    $(".bike_customizer_Oh_no").hide();
    $(".no-focus-outline").addClass("overflowHtml")
    $(".bike_customizer_bg").removeClass("bike_customizer_bgs");
})
// // Finish




// // Finish

// $(".Finish").click(function(){
//     // $(".drawer__content").show()
//     // $(".cart-drawer").show()    
//     // $(".mini-cart").show()
//     // $(".Finish_fixed").show();
//     $(".no-focus-outline").addClass("overflowHtml")
//     $(".bike_customizer_bg").addClass("bike_customizer_bgs");
// })
// // Finish 差
// $("#Finish_fixed_cha").click(function(){
//     // $(".Finish_fixed").hide();
//     $(".no-focus-outline").removeClass("overflowHtml")
//     $(".bike_customizer_bg").removeClass("bike_customizer_bgs");
// })

// $(".a").click(function(){
    
//     var items = [ {
//         quantity: 1,
//         id: Number(variantsId)
//     }];
//     for(var i =0; i<addPush.length; i++){
       

//         let item= {
//             quantity: 1,
//             id: Number(addPush[i])
//         } 
//         items.push(item);
      
//     } 
    
  
//     let formData = {
//         items
//     };
//     fetch(window.Shopify.routes.root + 'cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(formData)
//     })
//     .then(response => {
//         if (response.status == 200) {
//             window.location.href='/cart'
//         }
//     return response.json();
//     })
//     .catch((error) => {
//     console.error('Error:', error);
//     });
//   })

//










